import storageService from '../storageService';
import {MarketingParametersService} from './restServices';

const service = {};
service.updateOnboardingMarketingParams = async (
  objectType,
  objectId,
  eventType,
  content,
) => {
  try {
    const response = await MarketingParametersService.update(
      {
        endpoint: 'objectType',
        endpointParam: objectType,
        endpoint2: 'objectId',
        endpointParam2: objectId,
      },
      {content, token: storageService.getItem('token'), eventType},
    );
    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    console.debug(error);
  }
};

service.updateMarketingParameters = async (objectType, objectId, data) => {
  await MarketingParametersService.update(
    {
      endpoint: 'checkUpdate/objectType',
      endpointParam: objectType,
      endpoint2: 'objectId',
      endpointParam2: objectId,
    },
    {token: storageService.getItem('token'), ...data},
  );
};

service.getMarketingParamsActivity = async (objectType, objectId) => {
  try {
    const response = await MarketingParametersService.get(
      {
        endpoint: 'activity/objectType',
        endpointParam: objectType,
        endpoint2: 'objectId',
        endpointParam2: objectId,
      },
      {token: storageService.getItem('token')},
    );

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    console.debug(error);
  }
};

service.updateMarketingParamsActivity = async (
  activityType,
  activityData,
  objectType,
  objectId,
) => {
  try {
    const response = await MarketingParametersService.update(
      {
        endpoint: 'activity/objectType',
        endpointParam: objectType,
        endpoint2: 'objectId',
        endpointParam2: objectId,
      },
      {token: storageService.getItem('token'), activityType, activityData},
    );
    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    console.debug(error);
  }
};

service.checkTourFlagService = async (userId) => {
  try {
    const response = await MarketingParametersService.get(
      {
        endpoint: 'tourFlag/userId',
        endpointParam: userId,
      },
      {token: storageService.getItem('token')},
    );
    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    console.debug(error);
  }
};

const marketingParametersService = {...service};
export default marketingParametersService;
